export function endOfYear(year: number) {
    const x = new Date(year, 11, 31);
    return endOfDay(x);
  }

  export function startOfDay(d: Date) {
    const x = new Date(d);
    x.setHours(0, 0, 0, 0);
    return x;
  }

  export function endOfDay(d: Date) {
    const x = new Date(d);
    x.setHours(23, 59, 59, 999);
    return x;
  }

  // Woche beginnt Montag
  export function startOfWeekMonday(d: Date) {
    const x = startOfDay(d);
    const day = x.getDay(); // 0=So,1=Mo,...6=Sa
    const diffToMonday = (day + 6) % 7;
    x.setDate(x.getDate() - diffToMonday);
    return x;
  }

  export function endOfWeekSunday(d: Date) {
    const x = startOfWeekMonday(d);
    x.setDate(x.getDate() + 6);
    return endOfDay(x);
  }

 export function startOfMonth(d: Date) {
    const x = new Date(d.getFullYear(), d.getMonth(), 1);
    x.setHours(0, 0, 0, 0);
    return x;
  }

  export function endOfMonth(d: Date) {
    const x = new Date(d.getFullYear(), d.getMonth() + 1, 0); // letzter Tag im Monat
    return endOfDay(x);
  }

  export function startOfYear(year: number) {
    const x = new Date(year, 0, 1);
    x.setHours(0, 0, 0, 0);
    return x;
  }